import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Procedimiento } from "src/app/model/procedimiento";
import { FormGroup } from '@angular/forms';
import { Campo, DestinosTransferResponse, EnvioTramiteResultado, Pestania, ProcedimientoDinamico, TramiteImportResumen, TramiteTransferBundle } from '../model/procedimiendo-dinamico';

 
@Injectable({
  providedIn: 'root'
})
export class ProcedimientosService {

  API_URL:string = environment.API_URL; 

  constructor(
    private http: HttpClient,
   ) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  getProcedimiento(id: number): Observable<Procedimiento> {
    const url = `${this.API_URL}/procedimiento/get/${id}`;
    return this.http.get<Procedimiento>(url)
    .pipe(retry(1), catchError(this.handleError));
    
  }
  getProcedimientoByIdTramite(id: number): Observable<Procedimiento> {
    const url = `${this.API_URL}/procedimiento/get/tramite/${id}`;
    return this.http.get<Procedimiento>(url)
    .pipe(retry(1), catchError(this.handleError));
    
  }
  getProcedimientoCustom(id: number): Observable<Procedimiento> {
    const url = `${this.API_URL}/procedimiento/getCustom/${id}`;
    return this.http.get<Procedimiento>(url)
    .pipe(retry(1), catchError(this.handleError));
    
  }
  getProcedimientoCustomFormat(id: number): Observable<Procedimiento> {
    const url = `${this.API_URL}/procedimiento/getCustomFormat/${id}`;
    return this.http.get<Procedimiento>(url)
    .pipe(retry(1), catchError(this.handleError));
    
  }  
  getProcedimientos(): Observable<any> {
    return this.http
      .get<any>(`${this.API_URL}/procedimiento/list`);
  }

  updateVisibilityProc(id): Observable<any> {
    return this.http.get(`${this.API_URL}/procedimiento/visible/${id}`,{});
  }

  updateAperturaProc(id, form:FormData): Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/fechaApertura/${id}`,form);
  }

  updateCierreProc(id, form:FormData): Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/fechaCierre/${id}`,form);
  }

  updateProcedimiento(id,form:FormData):Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/editar/${id}`,form);
  }

  borrarProcedimiento(id):Observable<any>{
    return this.http.delete(`${this.API_URL}/procedimiento/borrar/${id}`);
  }
  copiarProcedimiento(id):Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/copiar/${id}`,{});
  }
  getProcedVisibles(): Observable<any> {
    return this.http.get(`${this.API_URL}/procedimiento/visible/list`,{});
  }

    // Error handling
    handleError(error: any) {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      //window.alert(errorMessage);
      return throwError(() => {
        return errorMessage;
      });
    }

    getListaByLista(lists: string): Observable<any[]> {
      const url = `${this.API_URL}/listados/get/lista/${lists}`;
      return this.http.get<any[]>(url)
        .pipe(retry(1), catchError(this.handleError));      
    }      
    getListaById(id: number): Observable<any> {
      const url = `${this.API_URL}/listados/get/${id}`;
      return this.http.get<any>(url)
        .pipe(retry(1), catchError(this.handleError));      
    }  

    borrarOpcionLista(id):Observable<any>{
      return this.http.delete(`${this.API_URL}/listados/borrar/${id}`);
    }    

    guardarOpcionLista(opcion: any) {
      return this.http.post<any>(`${this.API_URL}/listados/save`, opcion);
    }
    getListasDisponibles(): Observable<any[]> {
      const url = `${this.API_URL}/listados/listDisponibles`;
      return this.http.get<any[]>(url)
        .pipe(retry(1), catchError(this.handleError));      
    }   

  guardaProcedimiento(form:ProcedimientoDinamico):Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/saveProcCustom`,form);
  }    
  guardaPestaniaProcedimiento(idProc: number,form:Pestania):Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/saveProcCustom/${idProc}/pest`,form);
  } 
  guardaCampoPestaniaProcedimiento(idProc: number, idPest: number,form:Campo):Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/saveProcCustom/${idProc}/pest/${idPest}`,form);
  } 
  bajaPestaniaProcedimiento(form:Pestania):Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/bajaPestaniaProcCustom`,form);
  } 
  bajaCampoPestaniaProcedimiento(form:Campo):Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/bajaCampoProcCustom`,form);
  }

  // ---- Transferencia de trámites dinámicos entre entornos ----

  exportarTramite(id: number): Observable<TramiteTransferBundle> {
    return this.http.get<TramiteTransferBundle>(`${this.API_URL}/procedimiento/exportProcCustom/${id}`);
  }

  importarTramite(bundle: TramiteTransferBundle): Observable<TramiteImportResumen> {
    return this.http.post<TramiteImportResumen>(`${this.API_URL}/procedimiento/importProcCustom`, bundle);
  }

  getDestinosTransfer(): Observable<DestinosTransferResponse> {
    return this.http.get<DestinosTransferResponse>(`${this.API_URL}/procedimiento/transfer/destinos`);
  }

  enviarTramiteEntorno(id: number, destino: string): Observable<EnvioTramiteResultado> {
    return this.http.post<EnvioTramiteResultado>(`${this.API_URL}/procedimiento/enviarProcCustom/${id}`, { destino });
  }

}
